import React, { useState, useRef } from 'react';
import { Play, Pause, Volume2 } from 'lucide-react';

export default function MarshallAudioPlayer({ size = 'default', compact = false }) {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  if (size === 'small') {
    return (
      <div className="bg-gradient-to-r from-purple-900/30 to-pink-900/30 border border-purple-700/30 rounded-full px-4 py-2 flex items-center gap-3 inline-flex">
        <button onClick={togglePlay} className="text-white hover:text-purple-300 transition-colors">
          {isPlaying ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4" />}
        </button>
        <span className="text-white text-sm">Listen to Marshall Rosenberg's song</span>
        <audio ref={audioRef} src="https://customer-assets.emergentagent.com/job_belonging-sessions-1/artifacts/4ns74f05_Grandma%20And%20Jesus%20MBR.m4a" onEnded={() => setIsPlaying(false)} />
      </div>
    );
  }

  if (compact) {
    return (
      <div className="bg-gradient-to-br from-purple-900/20 to-pink-900/20 border border-purple-700/30 rounded-lg p-3">
        <div className="flex items-center gap-3">
          <button 
            onClick={togglePlay}
            className="flex-shrink-0 w-10 h-10 bg-purple-600 hover:bg-purple-500 rounded-full flex items-center justify-center text-white transition-all hover:scale-105"
          >
            {isPlaying ? <Pause className="h-5 w-5" /> : <Play className="h-5 w-5 ml-0.5" />}
          </button>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-bold text-white flex items-center gap-2">
              <Volume2 className="h-4 w-4 text-purple-400" />
              Marshall Rosenberg: "Grandma And Jesus"
            </h3>
            <p className="text-purple-200 text-xs truncate">
              A rare recording about compassion and unconditional hospitality
            </p>
          </div>
          <audio ref={audioRef} src="https://customer-assets.emergentagent.com/job_belonging-sessions-1/artifacts/4ns74f05_Grandma%20And%20Jesus%20MBR.m4a" onEnded={() => setIsPlaying(false)} />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-purple-900/20 to-pink-900/20 border border-purple-700/30 rounded-lg p-6">
      <div className="flex items-start gap-4">
        <button 
          onClick={togglePlay}
          className="flex-shrink-0 w-16 h-16 bg-purple-600 hover:bg-purple-500 rounded-full flex items-center justify-center text-white transition-all hover:scale-105"
        >
          {isPlaying ? <Pause className="h-8 w-8" /> : <Play className="h-8 w-8 ml-1" />}
        </button>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-white mb-2 flex items-center gap-2">
            <Volume2 className="h-5 w-5 text-purple-400" />
            Marshall Rosenberg: "Grandma And Jesus"
          </h3>
          <p className="text-purple-100 leading-relaxed text-sm mb-3">
            Marshall sings about one of the most instrumental moments of his life—watching his grandmother take in a homeless person during the Great Depression, feed them, and care for them with unconditional compassion. This story shaped his understanding of NVC.
          </p>
          <p className="text-purple-200 text-xs italic">
            A rare recording of Marshall's own song about compassion and hospitality
          </p>
        </div>
        <audio ref={audioRef} src="https://customer-assets.emergentagent.com/job_belonging-sessions-1/artifacts/4ns74f05_Grandma%20And%20Jesus%20MBR.m4a" onEnded={() => setIsPlaying(false)} />
      </div>
    </div>
  );
}
